import React from 'react';
import { AlertTriangle, MoonStar, RefreshCw, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const prettyDate = (d) => { try { return new Date(`${d}T00:00:00+05:30`).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', timeZone: 'Asia/Kolkata' }); } catch { return d; } };

/** Shown when a punch was refused because the phone gave no location. */
export const LocationHelp = ({ onRetry, onClose, busy }) => (
  <div className="rounded-lg border border-red-300 bg-red-50 p-3 text-xs text-red-900 space-y-2" data-testid="mytasks-location-help">
    <div className="flex items-start justify-between gap-2">
      <p className="font-semibold flex items-center gap-1"><AlertTriangle className="w-4 h-4" />Location is required for attendance</p>
      <button type="button" onClick={onClose} className="text-red-400 hover:text-red-700" data-testid="mytasks-location-help-close"><X className="w-4 h-4" /></button>
    </div>
    <ol className="list-decimal ml-4 space-y-0.5">
      <li>Turn ON <b>Location</b> on the phone (pull down the top bar → Location).</li>
      <li>Allow location for this site: tap the lock / ⓘ icon left of the web address → <b>Permissions</b> → <b>Location</b> → <b>Allow</b>.</li>
      <li>Step outside or near a window if it is slow, then tap <b>Try again</b>.</li>
    </ol>
    <Button type="button" size="sm" onClick={onRetry} disabled={busy} className="bg-red-600 hover:bg-red-700" data-testid="mytasks-location-retry"><RefreshCw className="w-3.5 h-3.5 mr-1" />Try again</Button>
  </div>
);

/** Yesterday's session was still open when the attendance day closed — HR enters the real check-out. */
export const MissedCheckoutBanner = ({ prev }) => {
  if (!prev) return null;
  return (
    <Card className="border-0 shadow-md border-l-4 border-l-orange-500 bg-orange-50" data-testid="mytasks-missed-checkout-banner"><CardContent className="p-4 space-y-1">
      <p className="font-semibold flex items-center gap-2"><MoonStar className="w-4 h-4 text-orange-600" />You did not check out on {prettyDate(prev.date)}</p>
      <p className="text-sm text-orange-900" data-testid="mytasks-missed-checkout-text">HR will enter your real check-out time — tell HR or your Transport Manager when you finished. Always tap Check Out at the end of your duty.</p>
    </CardContent></Card>
  );
};
